import React, { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { SafeArea } from "@capacitor-community/safe-area";

interface Props {
  children: React.ReactNode;
}

/**
 * Injects native safe-area insets (CSS vars) on iOS/Android only.
 * On web, does nothing.
 */
export const SafeAreaProvider: React.FC<Props> = ({ children }) => {
  useEffect(() => {
    if (Capacitor.getPlatform() !== "web") {
      SafeArea.enable({ config: {} }).catch(() => {
        // console.warn
      });
      return () => {
        SafeArea.disable({ config: {} }).catch(() => {
          // console.warn
        });
      };
    }
  }, []);

  return <>{children}</>;
};
